if (!customElements.get('supplements-modal')) {
  class SupplementsModal extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle(_event) {
      this.classList.toggle('is-open');
    }

    disconnectedCallback() {
      document.removeEventListener('supplements-modal:toggle', this.handleToggleRef);
    }
    
    connectedCallback() {
      document.addEventListener('supplements-modal:toggle', this.handleToggleRef);
    }
  }

  customElements.define('supplements-modal', SupplementsModal);
}